import { createContext } from "react";

export const menuItemsContext = createContext(null);